import useZWR from "@/utils/use-zwr";
import useFetcher from "@/utils/use-fetcher";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";

export interface VerifyCodeRequest {
  mobileNumber: string;
  verificationCode: string;
}

export interface VerifyCodeResponse {
  tempToken: string;
}

interface VerifyCodePathParameter {}

export const verifyCodeTemplateUrl = `/verification/sms/verify`;
export const verifyCodeKey: YWRKey<VerifyCodePathParameter> = {
  url: verifyCodeTemplateUrl,
  method: "post",
};
export default function useVerifyCode() {
  const fetcher = useFetcher<VerifyCodeRequest, VerifyCodeResponse>();
  return useYWR(verifyCodeKey, fetcher);
}
